import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function IdCard({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M10.09 8.14999C10.96 9.01999 10.96 10.45 10.09 11.33C9.21002 12.2 7.78002 12.2 6.90002 11.33C6.02002 10.45 6.02002 9.01999 6.90002 8.13999C7.77002 7.25999 9.20002 7.25999 10.08 8.13999M15 9.49999H19M17.4 13.5H15M12.09 16.5C11.91 16.06 11.64 15.66 11.29 15.346C10.7 14.796 9.93002 14.496 9.13302 14.496H7.83302C7.03302 14.496 6.26302 14.796 5.67602 15.336C5.32602 15.656 5.05902 16.046 4.87602 16.49M2.00002 18.5V5.53999C2.00002 4.40999 2.91002 3.48999 4.04002 3.48999H19.999C21.099 3.48999 21.999 4.37999 21.999 5.48999V18.49C21.999 19.59 21.099 20.49 19.999 20.49H3.99902C2.89402 20.49 1.99902 19.59 1.99902 18.49L2.00002 18.5Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default IdCard;